var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".plus-icon-svg{fill:#999;}")),React.createElement("rect",{"className":"plus-icon-svg","x":"5.04","width":"1.9","height":"11.96","rx":"0.95","ry":"0.95","key":1}),React.createElement("rect",{"className":"plus-icon-svg","x":"5.05","y":"0.02","width":"1.9","height":"11.96","rx":"0.95","ry":"0.95","transform":"translate(11.98 -0.04) rotate(90)","key":2})]);
}

PlusIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 11.96 11.96"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
